import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ItemStatus } from "@focus/focusUI";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError, of } from "rxjs";

const baseURL = "/api/v1/evolution-plot";

const initialState: any = {
  config: undefined,
  data: undefined,
  status: ItemStatus.READY,
  error: null,
};

const EvolutionPlotPlotSlice = createSlice({
  name: "events-evolution-plot",
  initialState,
  reducers: {
    getEvolutionPlotPlotRequest(state, _action) {
      state.status = ItemStatus.PENDING;
      state.error = null;
    },
    getEvolutionPlotPlotSuccess(state, action: PayloadAction<any>) {
      state.status = ItemStatus.READY;
      state.data = action.payload.data;
      state.config = action.payload.config;
    },
    getEvolutionPlotPlotFailure(state, action: PayloadAction<string>) {
      state.status = ItemStatus.ERROR;
      state.error = action.payload;
    },
  },
});

export const { getEvolutionPlotPlotRequest, getEvolutionPlotPlotSuccess, getEvolutionPlotPlotFailure } =
  EvolutionPlotPlotSlice.actions;

const getEvolutionPlotPlotEpic = (action, _state, { ajax }) => {
  return action.pipe(
    ofType(getEvolutionPlotPlotRequest.type),
    mergeMap(
      (
        action: PayloadAction<{
          id: number;
        }>
      ) => {
        const { id } = action.payload;
        return ajax.getJSON(`${baseURL}/${id}`).pipe(
          map((response: any) => getEvolutionPlotPlotSuccess(response)),
          catchError((error) => {
            return of(
              getEvolutionPlotPlotFailure(error.message || "Error fetching plot data")
            );
          })
        );
      }
    )
  );
};

export default {
  actions: EvolutionPlotPlotSlice.actions,
  reducer: EvolutionPlotPlotSlice.reducer,
  middleware: [getEvolutionPlotPlotEpic],
  selectors: EvolutionPlotPlotSlice.selectors,
};
